module.exports = __webpack_public_path__ + "img/Rel.Manager.fbe9e322.png";